import React from "react";
import DefaultLayout from "../layouts/DefaultLayout";
import ProjectsList from "../sections/Projects/ProjectsList";
import ProjectsFilter from "../sections/Projects/ProjectsFilter";
import Pagination from "../components/Pagination";
import DefaultHelmet from "../seo/DefaultHelmet";
import beaconWidgetIds from "../settings/beacon-widget-ids";
import useBeaconWidget from "../hooks/useBeaconWidget";
import useSchemaSettings from "../seo/schema/useSchemaSettings";
import { buildProjectsCollectionSchema } from "../seo/schema";

const Projects = ({ pageContext }) => {
		const {
			projects,
			technologies,
			currentTechnologySlug,
			projectsPerPage,
			totalCount,
			currentPage,
			pagesCount,
			categoryOriginPath,
			pageTitle,
			pageMetaData,
			pageHeader,
		} = pageContext;

		const isBaseProjectsPage = !currentTechnologySlug;
		const baseTitle = isBaseProjectsPage
			? pageMetaData?.title || pageTitle
			: pageTitle;
		const baseDescription = isBaseProjectsPage
			? pageMetaData?.description || "UTD Projects"
			: "UTD Projects, category: " + pageTitle;
		const helmetTitle = currentPage > 1
			? baseTitle + " | Projects page " + currentPage
			: baseTitle;
		const pageDescription = currentPage > 1
			? baseDescription + ", page: " + currentPage
			: baseDescription;
		const schemaContext = useSchemaSettings();
	const structuredData = buildProjectsCollectionSchema({
		schemaContext,
		projects,
		title: helmetTitle,
		description: pageDescription,
		currentPage,
		projectsPerPage,
		categoryOriginPath,
	});

	useBeaconWidget(beaconWidgetIds.GENERAL);

	return (
		<DefaultLayout>
			<DefaultHelmet
				title={helmetTitle}
				description={pageDescription}
				keywords={"UTD, Shopify, Shopify themes, eCommerce"}
				meta={currentPage > 1 ? [{ name: "robots", content: "noindex, follow" }] : []}
				structuredData={structuredData}
			/>

			<ProjectsFilter
				title={pageTitle}
				technologies={technologies}
				currentTechnologySlug={currentTechnologySlug}
				pageHeader={pageHeader}
			/>

			<ProjectsList
				projects={projects}
				totalCount={totalCount}
				projectsPerPage={projectsPerPage}
			/>

			<Pagination
				pagesCount={pagesCount}
				currentPage={currentPage}
				originalPath={categoryOriginPath}
			/>
		</DefaultLayout>
	)
};

export default Projects;
